import { createRouter, createWebHashHistory, RouteRecordRaw, createWebHistory } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/pageList',
        name: 'pageList',
        component: () => import('../views/pageList.vue')
    },
    {
        path: '/',
        name: 'home',
        component: () => import('../views/home.vue')
    },
    {
        path: '/services',
        name: 'services',
        component: () => import('../views/services.vue'),
    },
    {
        path: '/aboutUs',
        name: 'aboutUs',
        component: () => import('../views/aboutUs.vue')
    },
    {
        path: '/contactUs',
        name: 'contactUs',
        component: () => import('../views/contactUs.vue')
    },
    // {
    //   path: '/case1',
    //   name: 'case1',
    //   component: () => import('../views/case1.vue')
    // },
    // {
    //   path: '/case2',
    //   name: 'case2',
    //   component: () => import('../views/case2.vue')
    // },
    {
        path: '/question',
        name: 'question',
        component: () => import('../views/question.vue')
    },
    {
        path: '/aboutMINI',
        name: 'aboutMINI',
        component: () => import('../views/aboutMINI.vue')
    },
    {
        path: '/instructions',
        name: 'instructions',
        component: () => import('../views/instructions.vue')
    },
    {
        path: '/project',
        name: 'project',
        component: () => import('../views/project/index.vue')
    },
    {
        path: '/project/introduce',
        name: 'produce',
        component: () => import('../views/project/introduce.vue')
    },
    {
        path: '/project/gallery',
        name: 'gallery',
        component: () => import('../views/project/gallery.vue')
    },
    {
        path: '/project/detail',
        name: 'detail',
        component: () => import('../views/project/detail.vue')
    },
    {
        path: '/videos/play',
        name: 'play',
        component: () => import('../views/videos/play.vue')
    }
]

const router = createRouter({
    history: createWebHistory('/m/'),
    routes
})

export default router
